import { store } from "./store";
export { persistor } from "./store";
export type { RootState, AppDispatch } from "./store";

export default store;
